var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-template',{attrs:{"card-title":_vm.data.cardName,"is-loading":_vm.isLoading,"card-info":_vm.getCardInfo(),"card-type":"FTP"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57694db8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-ftp-files.vue
// module id = null
// module chunks = 